    <div class="wrong-account">
        <app-header-invitation-b2b-partnership-logos [invitation]="invitation"
                                                     [onlyClient]="true"
                                                     class="margin-bottom-50">
        </app-header-invitation-b2b-partnership-logos>
        <app-invitation-b2b-client-header-partner-infos [invitation]="invitation">
        </app-invitation-b2b-client-header-partner-infos>
        <mat-card class="wrong-account__card card">
            <mat-card-content>
                <div class="block-content">
                    <div class="block-content__text text-center"
                         [innerHtml]="
                    'Parmi vos organisations, laquelle est <strong>concernee par cette invitation</strong>.' | transloco">
                    </div>
                    <app-invitation-b2b-client-account-list [accounts]="_accounts"
                                                            [selectedAccount]="selectedAccount"
                                                            [invitation]="invitation"
                                                            [links]="links$ | async"
                                                            (selectAccount)="accountselected($event)">
                    </app-invitation-b2b-client-account-list>
                    <div class="
                    block-content__buttons
                    text-center margin-top-50">
                        <a mat-raised-button
                           color="primary"
                           (click)="clickContinue()">
                            {{ ('Continuer' | transloco) }}
                        </a>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
